import * as S from "components/common/Banner/Overlay.style";

const OverlayMobile = () => {
  return (
    <>
      <S.Overlay>
        <S.TextBanner variant="headline-01" color="white">
          <S.MainInfo>Área exclusiva de imprensa</S.MainInfo>
        </S.TextBanner>
        <S.TextBanner variant="headline-01" color="white">
          <S.SecondaryInfo>Bem-vindo à área exclusiva</S.SecondaryInfo>
          <S.SecondaryInfo>de relacionamento com</S.SecondaryInfo>
          <S.SecondaryInfo>profissionais da imprensa.</S.SecondaryInfo>
        </S.TextBanner>
        <S.BannerIndicator />
      </S.Overlay>
    </>
  );
};

export default OverlayMobile;
